var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: _vm.title,
        "close-on-click-modal": false,
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "inputForm",
          class: _vm.method === "view" ? "readonly" : "",
          attrs: {
            size: "small",
            model: _vm.inputForm,
            disabled: _vm.method === "view",
            "label-width": "120px",
          },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.doSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "按钮名称", prop: "name", rules: [] } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写按钮名称" },
                        model: {
                          value: _vm.inputForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "name", $$v)
                          },
                          expression: "inputForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "编码", prop: "code", rules: [] } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写编码" },
                        model: {
                          value: _vm.inputForm.code,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "code", $$v)
                          },
                          expression: "inputForm.code",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否隐藏", prop: "isHide", rules: [] } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写是否隐藏" },
                        model: {
                          value: _vm.inputForm.isHide,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "isHide", $$v)
                          },
                          expression: "inputForm.isHide",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "下一节点审核人",
                        prop: "next",
                        rules: [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写下一节点审核人" },
                        model: {
                          value: _vm.inputForm.next,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "next", $$v)
                          },
                          expression: "inputForm.next",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "sort", rules: [] } },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请填写排序",
                          step: 10,
                          min: 0,
                          max: 99999,
                        },
                        model: {
                          value: _vm.inputForm.sort,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm, "sort", $$v)
                          },
                          expression: "inputForm.sort",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "任务节点外键",
                        prop: "taskDef.id",
                        rules: [],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请填写任务节点外键" },
                        model: {
                          value: _vm.inputForm.taskDef.id,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputForm.taskDef, "id", $$v)
                          },
                          expression: "inputForm.taskDef.id",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.method === "add"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.continueDoSubmit()
                    },
                  },
                },
                [_vm._v("继续添加")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { size: "small", icon: "el-icon-circle-close" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _vm.method !== "view"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-circle-check" },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }